import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const OurCarsLoader = () => {
  return (
    <div className="mainSection">
      <Skeleton height={200} highlightColor="#fff" />
      <article
        style={{
          background: "#f1f1f1",
          borderTop: "1px solid #c7c7c7",
          paddingBottom: "15px",
          paddingTop: "15px",
        }}>
        <Skeleton
          height={35}
          count={5}
          inline
          highlightColor="#fff"
          containerClassName={"flex gap-4 justify-center px-[100px]"}
        />
        <hr className="mt-8 border-gray-300" />
        <Skeleton
          highlightColor="#fff"
          count={6}
          inline
          height={300}
          containerClassName={"grid xs:grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 mt-4 px-4 gap-4"}
        />
      </article>
    </div>
  );
};

export default OurCarsLoader;
